import { combineReducers } from 'redux';
import { authentication } from './auth';
import { featured } from './feature';
import { topStocks } from './topStocks';
import { patterns } from './patterns';
import { alerts } from './alerts';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createRootReducer = () => combineReducers({
  authentication,
  featured,
  topStocks,
  patterns,
  alerts,
});

export default createRootReducer;
